import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import { IconButton, Tooltip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import { useProductsByIds } from "../../services/productsService";
import { SelectProductsDialog } from "./SelectProductsDialog";

export function ProductSelector(props) {
    const { t } = useTranslation();
    const { openDialog } = useDialogBetter();

    const currentIds =
        props.disabled && props.previewProducts
            ? props.previewProducts.map((p) => p.id)
            : props.getFormProductIds();

    const { data: selectedProducts, isLoading } = useProductsByIds(currentIds);
    const [localProducts, setLocalProducts] = useState([]);

    useEffect(() => {
        if (!isLoading) {
            setLocalProducts(selectedProducts);
        }
    }, [isLoading]);

    const handleSelectProductId = (id) => {
        const currentIds = props.getFormProductIds();
        if (currentIds.includes(id)) {
            return;
        }
        const updatedIds = [...currentIds, id];
        props.setFormProductIds(updatedIds);
    };

    const handleUnselectProductId = (id) => {
        const currentIds = props.getFormProductIds();
        const updatedIds = currentIds.filter((productId) => productId !== id);
        props.setFormProductIds(updatedIds);
    };

    const handleOpenProductsDialog = () => {
        openDialog({
            Component: SelectProductsDialog,
            componentProps: {
                handleSelectProductId,
                handleUnselectProductId,
                getFormProductIds: props.getFormProductIds,
                setFormProductIds: props.setFormProductIds,
            },
        });
    };

    return (
        <Grid container direction={"column"} spacing={2}>
            <Grid container direction={"row"} alignItems={"center"} spacing={2}>
                <Grid item xs={1} />
                <Grid item xs={3}>
                    <Typography style={{ padding: "10px" }}>
                        {t("lead.leadForm.investment")}*
                    </Typography>
                </Grid>
                <Grid item xs={props.readOnly ? 8 : 7}>
                    <Typography style={{ padding: "10px" }}>
                        {t("lead.leadForm.product")}*
                    </Typography>
                </Grid>
                {!props.readOnly && (
                    <Grid item xs={1}>
                        <IconButton onClick={handleOpenProductsDialog} disabled={props.disabled}>
                            <AddCircleIcon />
                        </IconButton>
                    </Grid>
                )}
            </Grid>
            {localProducts?.map((product) => (
                <ProductRow
                    key={product.id}
                    product={product}
                    handleUnselectProductId={handleUnselectProductId}
                    disabled={props.disabled}
                    readOnly={props.readOnly}
                />
            ))}
        </Grid>
    );
}

function ProductRow(props) {
    const { product, handleUnselectProductId, disabled, readOnly } = props;
    const { t } = useTranslation();
    const productText = `${product.name_full} (${t("lead.leadForm.floor")} ${product.floor}, ${product.footage} m2)`;

    return (
        <Grid
            container
            direction={"row"}
            alignItems={"center"}
            spacing={2}
            key={product.id}
            style={{ marginBottom: "10px" }}
        >
            <Grid item xs={1}>
                <IconButton
                    onClick={() => handleUnselectProductId(product.id)}
                    disabled={disabled || readOnly}
                >
                    <RemoveCircleIcon />
                </IconButton>
            </Grid>
            <Grid item xs={3}>
                <Paper elevation={2} style={{ padding: "10px" }}>
                    <Typography>{product.investment.investment_name_sales}</Typography>
                </Paper>
            </Grid>
            <Grid item xs={7}>
                <Paper elevation={2} style={{ padding: "10px" }}>
                    <Tooltip title={productText}>
                        <Typography
                            style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {productText}
                        </Typography>
                    </Tooltip>
                </Paper>
            </Grid>
            <Grid item xs={1} />
        </Grid>
    );
}
